import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

import LogoutPage from "./Logout";
import logo from "../../../assets/images/logo/logo-color.png";
import ThemeToggleSwitch from "./ThemeToggle";

const Header = () => {
  const [rightSelect, setRightSelect] = useState("Eng");
  const [headerFix, setHeaderFix] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setHeaderFix(window.scrollY > 50);
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".header-profile")) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const path = window.location.pathname.split("/");
  const lastSegment = path[path.length - 1];
  const isUID = /^[0-9a-fA-F-]{36}$/.test(lastSegment);
  const name = (isUID ? path[path.length - 2] : path[path.length - 1])
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

  return (
    <div className={`header ${headerFix ? "is-fixed" : ""}`}>
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div className="dashboard_bar">{name}</div>
            </div>

            <div className="navbar-nav header-right">
              <div className="nav-item d-flex align-items-center">
                <ul>
                  <Dropdown
                    as="li"
                    className="nav-item dropdown header-profile"
                    show={menuOpen}
                    onToggle={() => setMenuOpen((prev) => !prev)}
                  >
                    <Dropdown.Toggle
                      as="a"
                      style={{
                        background: "#ffffff",
                        padding: 5,
                        borderRadius: "50%",
                        border: "2px solid rgb(54 36 101)",
                        height: "40px",
                        width: "40px",
                      }}
                      className="nav-link i-false c-pointer"
                    >
                      <img
                        src={logo}
                        alt=""
                        className="border-0"
                        style={{ objectFit: "contain" }}
                      />
                    </Dropdown.Toggle>

                    {menuOpen && (
                      <Dropdown.Menu
                        align="end"
                        className="dropdown-menu dropdown-menu-end"
                      >
                        <Link
                          to="/app-profile"
                          className="dropdown-item ai-icon"
                        >
                          <svg
                            className="text-primary me-1"
                            width={18}
                            height={18}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx={12} cy={7} r={4} />
                          </svg>
                          <span className="ms-2">Profile</span>
                        </Link>

                        {/* <Link
                          to="/email-inbox"
                          className="dropdown-item ai-icon"
                        >
                          <svg
                            className="text-success me-1"
                            width={18}
                            height={18}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <polyline points="22,6 12,13 2,6" />
                          </svg>
                          <span className="ms-2">Inbox</span>
                        </Link> */}

                        <div className="dropdown-item ai-icon">
                          <ThemeToggleSwitch />
                        </div>

                        <LogoutPage />
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
